import type {
  EIP1193Provider,
  EvmWalletProvider,
} from '../../../EvmWalletProvider.types';

type GetActiveNetworkId = (args: {
  eip1193: EIP1193Provider;
}) => ReturnType<EvmWalletProvider['getActiveNetworkId']>;

/** @not-instrumented */
export const getActiveNetworkId: GetActiveNetworkId = async ({ eip1193 }) => {
  const chainIdHex = (await eip1193.request({
    method: 'eth_chainId',
    params: [],
  })) as string;

  return { networkId: `${parseInt(chainIdHex, 16)}` };
};
